import { createContext } from "react";
import { contextAsyncFunctionInit, contextFunctionInit } from "sprint-common-web";

import { OrderListingConfig, getDefaultOrderListingConfig } from "../config/OrderListingConfig";
import { OrderListingFilters } from "../hooks/useOrderListingFilters";
import { OrderListingItem } from "../OrderListingItem";

interface IOrderListingContext {
    items: OrderListingItem[];
    selectedItems: OrderListingItem[];
    totalItems: number;
    mergeListItems: OrderListingItem[];
    pinnedItems: string[];
    listingConfig: OrderListingConfig;
    saveListingConfig(config: OrderListingConfig): void;
    addItemToMergeList(item: OrderListingItem): void;
    removeItemsFromMergeList(itemsIds: string[]): void;
    setSelectedItems(selectedItems: OrderListingItem[]): void;
    reloadData(filters: OrderListingFilters): Promise<void>;
    approveDelivery(orderId: string): void;
    completeRejected(orderId: string, completionDetails?: string): void;
    reject(orderId: string, rejectReason?: string): void;
    approveDeliveries(orderIds: string[]): void;
    deleteOrder(orderId: string): void;
    updateDeliveryFolder(orderId: string, deliveryFolder: string): void;
    updateOrder(order: Partial<OrderListingItem> & Required<Pick<OrderListingItem, "id">>): void;
    togglePinnedOrder(orderId: string): void;
}

export const OrderListingContext = createContext<IOrderListingContext>({
    items: [],
    selectedItems: [],
    mergeListItems: [],
    pinnedItems: [],
    totalItems: 0,
    listingConfig: getDefaultOrderListingConfig(),
    setSelectedItems: contextFunctionInit,
    addItemToMergeList: contextFunctionInit,
    saveListingConfig: contextFunctionInit,
    removeItemsFromMergeList: contextFunctionInit,
    reloadData: contextAsyncFunctionInit,
    approveDelivery: contextFunctionInit,
    reject: contextFunctionInit,
    completeRejected: contextFunctionInit,
    approveDeliveries: contextFunctionInit,
    deleteOrder: contextFunctionInit,
    updateDeliveryFolder: contextFunctionInit,
    updateOrder: contextFunctionInit,
    togglePinnedOrder: contextFunctionInit
});
